// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oc-header {
  font-family: "DMSans-Regular";
  background-color: var(--oc-primary-bg);
}

.oc-header .navbar-nav .nav-link {
  /* font-size: 1.625em; */
  padding-left: 12px;
  color: #fff;
  margin-left: 10px;
}

.oc-header .navbar-nav .nav-link.active,
.oc-header .navbar-nav .show > .nav-link {
  font-family: "DMSans-Regular";
  position: relative;
}

.oc-header .navbar-nav .nav-link.active::after,
.nav-link.active,
.oc-header .navbar-nav .show > .nav-link::after {
  content: "";
  width: 90%;
  display: block;
  background-color: var(--oc-primary-color);
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  position: absolute;
  /* top: 100%; */
  /* left: 50%; */
  /* transform: translateX(-50%); */
}

.oc-nav-right .oc-btn {
  font-family: DMSans-Bold;
}

@media screen and (min-width: 990px) {
  .oc-header .navbar-nav .nav-link {
    font-size: 26px;
    padding-left: 1.675em;
    padding-right: 1.675em;
  }
  .nav-link.active {
    content: "";
    width: 100%;
    /* margin-left: 10px; */
    display: block;
    background-color: transparent;
    border-radius: 0;
    border-bottom: 4px solid var(--oc-primary-color);
    /* position: absolute; */
  }

  .oc-header .navbar-nav .nav-link {
    font-size: 20px;
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/Header.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,UAAU;EACV,cAAc;EACd,yCAAyC;EACzC,6BAA6B;EAC7B,gCAAgC;EAChC,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,eAAe;IACf,qBAAqB;IACrB,sBAAsB;EACxB;EAIA;IACE,WAAW;IACX,WAAW;IACX,uBAAuB;IACvB,cAAc;IACd,6BAA6B;IAC7B,gBAAgB;IAChB,gDAAgD;IAChD,wBAAwB;EAC1B;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AAjBF","sourcesContent":[".oc-header {\n  font-family: \"DMSans-Regular\";\n  background-color: var(--oc-primary-bg);\n}\n\n.oc-header .navbar-nav .nav-link {\n  /* font-size: 1.625em; */\n  padding-left: 12px;\n  color: #fff;\n  margin-left: 10px;\n}\n\n.oc-header .navbar-nav .nav-link.active,\n.oc-header .navbar-nav .show > .nav-link {\n  font-family: \"DMSans-Regular\";\n  position: relative;\n}\n\n.oc-header .navbar-nav .nav-link.active::after,\n.nav-link.active,\n.oc-header .navbar-nav .show > .nav-link::after {\n  content: \"\";\n  width: 90%;\n  display: block;\n  background-color: var(--oc-primary-color);\n  border-top-right-radius: 12px;\n  border-bottom-right-radius: 12px;\n  position: absolute;\n  /* top: 100%; */\n  /* left: 50%; */\n  /* transform: translateX(-50%); */\n}\n\n.oc-nav-right .oc-btn {\n  font-family: DMSans-Bold;\n}\n\n@media screen and (min-width: 990px) {\n  .oc-header .navbar-nav .nav-link {\n    font-size: 26px;\n    padding-left: 1.675em;\n    padding-right: 1.675em;\n  }\n}\n\n@media screen and (min-width: 990px) {\n  .nav-link.active {\n    content: \"\";\n    width: 100%;\n    /* margin-left: 10px; */\n    display: block;\n    background-color: transparent;\n    border-radius: 0;\n    border-bottom: 4px solid var(--oc-primary-color);\n    /* position: absolute; */\n  }\n\n  .oc-header .navbar-nav .nav-link {\n    font-size: 20px;\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
